/**
 * Az oldal kézzel karbantartott adatai — amit a backend (még) nem tud.
 *
 * A PATCH_LOG már csak TARTALÉK: 2026-09-26 óta a patch-naplót és az állapotsáv
 * „DSO …” feliratát a backend játékfrissítés-figyelője adja (`/api/game/builds`).
 * Ez a lista csak akkor látszik, ha az API nem elérhető vagy még üres.
 * A szolgáltatás tényleges állapotát (working / updating) a backendből
 * (`/api/owner/status`) olvassuk.
 */

export const DISCORD_URL = 'https://discord.gg/mortisengine';

// A Codex oldala (mortisengine.com): ott van a fiók, a vásárlás és az előfizetés kezelése. A bot oldalán csak a
// belépett felhasználó lapjairól linkelünk rá — a belépő lapon nincs link.
export const CODEX_URL = 'https://mortisengine.com';
export const CODEX_LABEL = 'mortisengine.com';
// Megjelenítéshez (pl. az adatvédelmi oldalon a link szövege): https:// nélkül.
export const DISCORD_LABEL = DISCORD_URL.replace(/^https?:\/\//, '');

/** A legfrissebb elöl. `date`: ISO nap, `game`: mi változott a játékban. */
export const PATCH_LOG = [
  { date: '2026-09-23', game: 'DSO patch' },
  { date: '2026-09-17', game: 'DSO client 180' },
  { date: '2026-09-15', game: 'DSO patch' },
  { date: '2026-09-14', game: 'DSO patch' },
  { date: '2026-09-10', game: 'DSO patch' },
];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** '2026-09-23' → '23 Sep' — időzóna-független, mert csak a szöveget bontjuk. */
export function shortDate(iso) {
  const [, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!m || !d) return iso;
  return `${d} ${MONTHS[m - 1]}`;
}
